import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

/**
 * Created by Jerker Nord on 2020-08-24.
 */

export interface BitmapTextStyleData {
    fontName: string;
    fontSize?: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}

export class MonkeysGoldBitmapText extends PIXI.BitmapText{

    private _inUse:boolean = false;

    constructor(text:string, style:BitmapTextStyleData) {
        super(text, style);
    }

    get inUse():boolean {
        return this._inUse;
    }

    set inUse(value:boolean) {
        this._inUse = value;
    }
}